import fetch from 'services/request';

import {
  IApiGetAppointments,
  IApiGetListStaffByTime,
  IApiGetMultipleSettingBackground,
  IApiGetSettingBackground,
  IApiGetTableAppointment,
  IBodyApiMakeAppointment,
  IBodyApiMakeLockTime,
  IBodyApiUpdateAppointmentDetail,
  IBodyApiUpdateAppointmentWithDrop,
  IBodyApiBookingMultiple,
  IAppointmentMasterDataParams,
  IBodyApiUpdateStaffsColor,
  IBodyApiUpdateAppointmentV2,
  IBodyApiUpdateStatusMultipleAppointment,
} from './types/api';

import { APPOINTMENT_STATUS, PROLONGED_TIME_STATUS } from './constants';
import queryString from 'query-string';
import { IBodyApiUpdateStatusApt } from 'services/response';
import { IApiParamsGetSummaryByStatus, IBodyApiQuickBooking } from './types/appointment';

export const getAppointments = async (params: IApiGetAppointments) => {
  return fetch({
    method: 'get',
    url: '/api/v1/appointment/all',
    params,
  });
};

export const getTableAppointments = async (params: IApiGetTableAppointment) => {
  const paramsPasser = queryString.stringify({ ...params }, { arrayFormat: 'bracket' });
  return fetch({
    method: 'get',
    url: `/api/v1/appointment/list-table?${paramsPasser.replaceAll('[]', '')}`,
  });
};

const getLockBreakTimes = (params: IApiGetAppointments) => {
  return fetch({
    method: 'get',
    url: '/api/v1/appointment/lock-time',
    params,
  });
};
const removeLockBreakTimes = (offDayStaffId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/appointment/lock-time/${offDayStaffId}`,
  });
};

const makeNewAppointment = (body: IBodyApiMakeAppointment) => {
  return fetch({
    method: 'post',
    url: '/api/v2/appointment/booking',
    body,
  });
};

const makeLockTime = (body: IBodyApiMakeLockTime) => {
  return fetch({
    method: 'post',
    url: '/api/v1/appointment/lock-time',
    body,
  });
};

const getStaffTimeSlot = (staffId: string | null | undefined, date: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/appointment/available-time-slot-staff',
    params: { staffId: staffId || '', date, type: 'POS' },
  });
};

const getStaffTimeSlotByDate = (date: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/appointment/available-time-slot-staff',
    params: { date, type: 'POS' },
  });
};

const addMoreTimeClockTime = (clockId: string) => {
  return fetch({
    method: 'post',
    url: 'api/v1/appointment/lock-time/prolonged-time',
    body: { clockId, type: 'ADD' },
  });
};

const minusMoreTimeClockTime = (clockId: string) => {
  return fetch({
    method: 'post',
    url: 'api/v1/appointment/lock-time/prolonged-time',
    body: { clockId, type: 'MINUS' },
  });
};

const addMoreTimeAppointment = (body: { status: PROLONGED_TIME_STATUS; appointmentId: string }) => {
  return fetch({
    method: 'post',
    url: 'api/v1/appointment/prolonged-time',
    body,
  });
};

const updateAppointmentWithDrop = (body: IBodyApiUpdateAppointmentWithDrop) => {
  return fetch({
    method: 'post',
    url: 'api/v1/appointment/update-with-drop',
    body,
  });
};

const deleteAppointment = (appointmentId: string) => {
  return fetch({
    method: 'delete',
    url: 'api/v1/appointment/' + appointmentId,
  });
};

const updateDetailAppointment = (body: IBodyApiUpdateAppointmentDetail) => {
  return fetch({
    method: 'put',
    url: '/api/v2/appointment/booking',
    body,
  });
};
const updateStatusApt = (body: IBodyApiUpdateStatusApt) => {
  return fetch({
    method: 'post',
    url: '/api/v1/appointment/update-status',
    body,
    autoToast: true,
  });
};

const getListStaffAvailableBooking = (date: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/staff/available-booking',
    params: { date },
  });
};

const getListStaffsOff = (startDate: string, endDate: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/staff/staff-off-booking',
    params: { startDate, endDate },
  });
};

const makeQuickBooking = (body: IBodyApiQuickBooking) => {
  return fetch({
    method: 'post',
    url: '/api/v2/appointment/quick-booking',
    body,
  });
};

const getCategoriesByStaff = (staffId: string) => {
  return fetch({
    method: 'get',
    url: 'api/v1/category/get-all-booking',
    params: {
      staffId,
    },
  });
};

const addAnybody = () =>
  fetch({
    method: 'post',
    url: '/api/v1/staff/add-any-body',
  });
const removeAnybody = (staffId: string) =>
  fetch({
    method: 'delete',
    url: `/api/v1/staff/delete/${staffId}`,
  });

const checkoutAppointment = (appointmentId: string) =>
  fetch({
    method: 'get',
    url: `/api/v1/appointment/checkout/${appointmentId}`,
  });

const getSettingBackground = () =>
  fetch({
    method: 'get',
    url: '/api/v1/appointment/setting-background',
  });

const updateSettingBackground = (body: IApiGetSettingBackground) =>
  fetch({
    method: 'post',
    url: '/api/v1/appointment/setting-background',
    body,
  });

const updateMultipleSettingBackground = (body: IApiGetMultipleSettingBackground) =>
  fetch({
    method: 'post',
    url: '/api/v1/appointment/multiple-setting-background',
    body,
  });

const getSummaryAppointmentByDate = (params: { startDate: string; endDate: string }) =>
  fetch({
    method: 'get',
    url: '/api/v1/report/summary-appointment-by-date',
    params,
  });

const getSummaryByStatus = (params: IApiParamsGetSummaryByStatus) =>
  fetch({
    method: 'get',
    url: '/api/v1/appointment/summary-by-status',
    params,
  });
const getListStaffByTime = (body: IApiGetListStaffByTime) =>
  fetch({
    method: 'post',
    url: '/api/v1/appointment/list-staff-by-time',
    body,
  });

const bookingMultiple = (body: IBodyApiBookingMultiple) =>
  fetch({
    method: 'post',
    url: '/api/v1/appointment/booking-multiple',
    body,
    autoToast: false,
  });

const updateBookingV2 = (body: IBodyApiUpdateAppointmentV2) =>
  fetch({
    method: 'put',
    url: '/api/v1/appointment/update-booking-v2',
    body,
    autoToast: false,
  });

const getAvailableTimeSlotStore = (date: string) =>
  fetch({
    method: 'get',
    url: '/api/v1/appointment/available-time-slot-store',
    params: { date, type: 'POS' },
  });

const getAppointmentMasterData = (params: IAppointmentMasterDataParams) =>
  fetch({
    method: 'get',
    url: '/api/v1/appointment/list-by-staff-working',
    params,
  });

const updateStaffsColor = (body: IBodyApiUpdateStaffsColor[]) =>
  fetch({
    method: 'post',
    url: '/api/v1/staff/update-color',
    body,
  });

const shopOffDay = (startTime: string, endTime: string, staffId?: string) => fetch({
  method: 'get',
  url: '/api/v1/appointment/shop-off-day',
  params: { startTime, endTime, staffId },
});

const listStaffNextAvailable = () => fetch({
  method: 'get',
  url: '/api/v1/appointment/list-staff-next-available',
});

const getAppointmentDetailV2 = (id: string) => fetch({
  method: 'get',
  url: `/api/v1/appointment/detail-v2/${id}`,

});

// 
const aptSendSMS = (phone: string, callerId: string) => fetch({
  method: 'post',
  url: '/api/v1/appointment/send-sms',
  body: { phone, callerId }
});

const getSummaryCallerId = (params: { startDate: string; endDate: string }, configs?: any) => {
  return fetch({
    method: 'get',
    url: '/api/v1/appointment/summary-caller-id',
    params,
    configs,
  });
};

const getHistoryCallerId = (params: { startDate: string; endDate: string; page: number; pageSize: number }, configs?: any) => {
  return fetch({
    method: 'get',
    url: '/api/v1/appointment/history-caller-id',
    params,
    configs,
  });
};

const updateStaffMultipleAppointment = (body: { appointmentId: string; staffId: string }) => 
  fetch({
    method: 'post',
    url: '/api/v1/appointment/update-staff',
    body,
  });

const updateDurationAppointment = (body: { appointmentId: string; duration: number }) => 
  fetch({
    method: 'post',
    url: '/api/v1/mobile-app/owner/update-duration-appointment',
    body,
  });

  // /api/v1/appointment/update-color
const updateColorAppointment = (body: { appointmentId: string; color: string }) => 
  fetch({
    method: 'post',
    url: '/api/v1/appointment/update-color',
    body,
  });

  // /api/v1/appointment/update-status-multiple
const updateStatusMultipleAppointment = (body: IBodyApiUpdateStatusMultipleAppointment) => 
  fetch({
    method: 'post',
    url: '/api/v1/appointment/update-status-multiple',
    body,
  });

const appointmentApis = {
  getAppointments,
  getTableAppointments,
  getLockBreakTimes,
  removeLockBreakTimes,
  makeNewAppointment,
  makeLockTime,
  getStaffTimeSlot,
  getStaffTimeSlotByDate,
  addMoreTimeAppointment,
  addMoreTimeClockTime,
  minusMoreTimeClockTime,
  updateAppointmentWithDrop,
  deleteAppointment,
  updateDetailAppointment,
  updateStatusApt,
  getListStaffAvailableBooking,
  getListStaffsOff,
  makeQuickBooking,
  getCategoriesByStaff,
  addAnybody,
  removeAnybody,
  checkoutAppointment,
  getSettingBackground,
  updateSettingBackground,
  updateMultipleSettingBackground,
  getSummaryAppointmentByDate,
  getSummaryByStatus,
  getListStaffByTime,
  bookingMultiple,
  getAvailableTimeSlotStore,
  getAppointmentMasterData,
  updateStaffsColor,
  shopOffDay,
  listStaffNextAvailable,
  getAppointmentDetailV2,
  updateBookingV2,
  aptSendSMS,
  getSummaryCallerId,
  getHistoryCallerId,
  updateStaffMultipleAppointment,
  updateDurationAppointment,
  updateColorAppointment,
  updateStatusMultipleAppointment,
};

export default appointmentApis;
